import styled from "styled-components";


export const BatchDocumentActions = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const DownloadButton = styled.button`
background-color: transparent;
border: none;
padding: 0;
margin: 0;
`

export const DocumentLink = styled.div`
    line-height: 21px;
    text-transform: capitalize;
    color: #2455ef;
    font-weight: bold;

    &:hover {
      text-decoration-line: underline;
      cursor: pointer;
    }
`